<template>
    <div class="m-2">
        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Тип</span>
            <span class="w-2/3">{{ typesTitle[entity.type] }}</span>
        </div>
        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Заголовок</span>
            <span class="w-2/3">{{ entity.title }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Описание</span>
            <span class="w-2/3">{{ entity.description }}</span>
        </div>

        <div class="flex items-start mt-4" v-if="entity.type === 'variants'">
            <span class="w-1/3 font-bold">Варианты</span>
            <span class="w-2/3">
                <template v-for="variant in entity.variants">
                    <div :key="variant.id">{{variant.title}}</div>
                </template>
            </span>
        </div>
    </div>
</template>

<script>
    const { formatDate } = require('../../utils/views');
    const { DELIVERY_TYPE } = require('../../utils/order');
    const moment = require('moment');

    export default {
        props: {
            entity: {
                type: Object,
                default: () => {},
            },
        },

        data() {
            return {
                typesTitle: {
                    estimation: 'Оценка',
                    variants: 'Выбор варианта',
                    comment: 'Текст',
                }
            };
        },
        created() {
        },

        methods: {
            formatDate(date) {
                return formatDate(date);
            },

            formatDateShort(data) {
                return moment(data).format('DD.MM.YYYY');
            },

        },
    };
</script>
